// extracted by mini-css-extract-plugin
export default {"label":"Bvhvw","label-active":"L8P_z"};